"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Button_1 = require("@mui/material/Button");
var Modal_1 = require("@mui/material/Modal");
var react_1 = require("react");
var TextField_1 = require("@mui/material/TextField");
var CloudUpload_1 = require("@mui/icons-material/CloudUpload");
var Stack_1 = require("@mui/material/Stack");
var AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var DateTimePicker_1 = require("@mui/x-date-pickers/DateTimePicker");
var FormGroup_1 = require("@mui/material/FormGroup");
var FormControlLabel_1 = require("@mui/material/FormControlLabel");
var Checkbox_1 = require("@mui/material/Checkbox");
var material_1 = require("@mui/material");
var Post_1 = require("../models/Post");
var dayjs = require("dayjs");
var Toast_1 = require("../shared/utilities/Toast");
//import dayjs from 'dayjs' // ES 2015
dayjs().format();
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
var VisuallyHiddenInput = styles_1.styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
var PostModal = react_1.forwardRef(function (props, ref) {
    var _a = React.useState(false), isInvalid = _a[0], setIsInvalid = _a[1];
    var _b = Toast_1.default(), showErrorMessage = _b.showErrorMessage, showSuccessMessage = _b.showSuccessMessage;
    var _c = React.useState(false), postTimeInvalid = _c[0], setPostTimeInvalid = _c[1];
    var _d = React.useState(dayjs(new Date())), futurePostTime = _d[0], setFuturePostTime = _d[1];
    var _e = React.useState(''), postBody = _e[0], setPostBody = _e[1];
    var _f = React.useState(''), postimageUrl = _f[0], setPostImageUrl = _f[1];
    var _g = React.useState(''), id = _g[0], setId = _g[1];
    var _h = React.useState(true), postNowChk = _h[0], setPostNowChk = _h[1];
    var _j = React.useState(true), sendEmailNotificationChk = _j[0], setSendEmailNotificationChk = _j[1];
    var _k = React.useState(false), postLaterChk = _k[0], setPostLaterChk = _k[1];
    var _l = React.useState(false), open = _l[0], setOpen = _l[1];
    var _m = React.useState(undefined), file = _m[0], setFile = _m[1];
    var _o = React.useState(false), isMobile = _o[0], setIsMobile = _o[1];
    //choose the screen size 
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    };
    var handleOpen = function (post) {
        setOpen(true);
        setPostBody(post.PostBody);
        setId(post.PostId);
        setPostImageUrl(post.PostImageLocation);
        setPostNowChk(post.PostImmediatelyInd);
        setPostLaterChk(!post.PostImmediatelyInd);
        if (post.PostFutureTime != null && post.PostFutureTime != "") {
            setFuturePostTime(dayjs(post.PostFutureTime));
        }
        else {
            setFuturePostTime((dayjs(new Date()).add(1, "day")));
        }
        setSendEmailNotificationChk(post.SendEmailNotificationInd);
        setFile(undefined);
        setIsInvalid(post.PostId !== '');
        window.addEventListener("resize", handleResize);
        handleResize();
    };
    var handleFileChange = function (e) {
        var file = e.target.files[0];
        setPostImageUrl(URL.createObjectURL(file));
        setFile(file);
    };
    var handleClose = function () {
        setOpen(false);
        window.removeEventListener("resize", handleResize);
    };
    var clickPostNow = function () {
        setPostLaterChk(postNowChk);
        setPostNowChk(!postNowChk);
    };
    var clickPostLater = function () {
        setPostNowChk(postLaterChk);
        setPostLaterChk(!postLaterChk);
    };
    var handlePostBodyChange = function (e) {
        setPostBody(e.target.value);
    };
    var handlEmailNotificationIndChange = function (e) {
        setSendEmailNotificationChk(e.target.checked);
    };
    var handlPostTimeChange = function (e) {
        console.log('post time hit');
        if (e != null) {
            setPostTimeInvalid(!e.isValid() || e <= dayjs(new Date()));
            setFuturePostTime(e);
        }
    };
    react_1.useImperativeHandle(ref, function () { return ({
        handleOpen: handleOpen
    }); });
    return (React.createElement(Modal_1.default, { open: open, onClose: handleClose, "aria-labelledby": "parent-modal-title", "aria-describedby": "parent-modal-description" },
        React.createElement(Box_1.default, { sx: __assign(__assign({}, style), { width: isMobile ? '90%' : '50%', overflowY: 'auto', maxHeight: '85%' }) },
            React.createElement(TextField_1.default, { label: "Content", multiline: true, fullWidth: true, rows: 8, variant: "outlined", margin: "normal", onChange: handlePostBodyChange, value: postBody, error: isInvalid && postBody === "", helperText: isInvalid && postBody === "" ? 'Post content is required' : '' }),
            React.createElement(FormGroup_1.default, null,
                React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, null), checked: sendEmailNotificationChk, label: "Send Email Notification", onChange: handlEmailNotificationIndChange })),
            React.createElement(material_1.FormControl, null,
                React.createElement(FormGroup_1.default, null,
                    React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, null), label: "Post Immediately", name: "timeToPost", checked: postNowChk, onChange: function () {
                            clickPostNow();
                        } }))),
            React.createElement(material_1.FormControl, null,
                React.createElement(FormGroup_1.default, null,
                    React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, null), label: "Specify Post Time", name: "timeToPost", checked: postLaterChk, onChange: function () {
                            clickPostLater();
                        } }))),
            React.createElement("br", null),
            React.createElement("div", { hidden: postNowChk },
                React.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs },
                    React.createElement(DateTimePicker_1.DateTimePicker, { disablePast: true, defaultValue: futurePostTime, onChange: handlPostTimeChange, label: "Post Time", slotProps: { textField: { fullWidth: true, margin: "normal" } } })),
                postTimeInvalid &&
                    React.createElement(material_1.FormHelperText, { error: true }, "Post time is invalid")),
            React.createElement(Button_1.default, { component: "label", variant: "contained", startIcon: React.createElement(CloudUpload_1.default, null) },
                "Upload Picture",
                React.createElement(VisuallyHiddenInput, { type: "file", onChange: handleFileChange })),
            React.createElement("br", null),
            postimageUrl !== '' && postimageUrl !== null &&
                React.createElement("a", { href: postimageUrl, download: true }, "View Image"),
            React.createElement("br", null),
            React.createElement(Stack_1.default, { spacing: 2, direction: "row", justifyContent: "flex-end" },
                React.createElement(Button_1.default, { variant: "outlined", onClick: function () {
                        handleClose();
                    } }, "Cancel"),
                React.createElement(Button_1.default, { variant: "contained", onClick: function () {
                        if (postBody.trim() === "" || !futurePostTime.isValid()) {
                            setIsInvalid(true);
                            showErrorMessage('Post information is not valid!');
                            return;
                        }
                        var post = new Post_1.PostModel();
                        post.PostId = id;
                        post.PostBody = postBody;
                        post.PostImmediatelyInd = postNowChk;
                        post.SendEmailNotificationInd = sendEmailNotificationChk;
                        post.PostFutureTime = postNowChk ? null : futurePostTime;
                        if (file != undefined) {
                            var reader_1 = new FileReader();
                            reader_1.readAsDataURL(file);
                            reader_1.onload = function () {
                                if (reader_1.result != null) {
                                    console.log('file name', file.name);
                                    props.upsertPost(post, reader_1.result.toString().split('base64,')[1], file.name);
                                }
                            };
                            reader_1.onerror = function (error) {
                                console.log('Error: ', error);
                            };
                        }
                        else {
                            props.upsertPost(post, null, null);
                        }
                        handleClose();
                    } }, "Confirm")))));
});
exports.default = PostModal;
//# sourceMappingURL=PostModal.js.map